export default "__VITE_ASSET__BKGqjMcw__"